import React, { useRef, useEffect, useState } from "react";

import useHttp from "../../../../hooks/use-http";

import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const FarmerCropSowingDetailReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/farmerwise");
  };
  const [employeeId, setEmployeeId] = useState();
  const [employeeData, setEmployeeData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [regionData, setRegionData] = useState([]);
  const [stateName, setStateName] = useState();
  const [stateData, setStatedata] = useState([]);

  const [collectionCenterId, setCollectionCenterId] = useState();
  const [collecticnCenterdata, setCollectionCenter] = useState([]);
  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const { sendRequest: getWarehouseData } = useHttp();

  const [cropAreaData, setCropAreaData] = useState([]);

  const [cropwiseAreaCovered, setcropwiseAreaCovered] = useState([]);
  const [executivewiseProcurement, setexecutivewiseProcurement] = useState([]);
  const [executivewiseAreaCovered, setexecutivewiseAreaCovered] = useState([]);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange",e.target.value)
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 90);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate",toDate)

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const { sendRequest: getfarmerdeal } = useHttp();

  const loadCountData = (id) => {
    fillprocurementData(id);
  };

  const fillprocurementData = (employeeId, regionId) => {
    var newList = [];

    var urlfilter = "";

    var urlfilter = "";

    // urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
    // urlfilter = urlfilter + `&toDate=${selectedToDate}`;

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.fromDate.value).format("DD/MM/YYYY")}`;

    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.toDate.value).format("DD/MM/YYYY")}`;

    // console.log("urlfilter", urlfilter);

    if (employeeId > 0) {
      urlfilter =urlfilter+ `&fieldExecutiveId=${employeeId}`;
    }

    if (regionId > 0) {
      urlfilter = urlfilter + `&regionId=${regionId}`;
    }
    if (stateName && typeof stateName === "string" && stateName.trim().length > 0) {
      const sanitizedState = stateName.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }

    var url = `/api/farmerCropSowingReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        // console.log("reportdata1", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillprocurementData(0, 0);
  }, [getprocurementData]);

  const fieldsToExport = [
    "farmerName",
    "farmerNo",
    "executiveName",
    "state",
    "villageName",
    "lga",
    "seasonName",
    "cropType",
    "cropName",
    "varietyName",
    "plotArea",
    "plotAreaUnit",
    "fieldOperationDate",
    "irrigationDate",
    "landPreparationType",
    "fieldOperationName",
    "transplantedArea",
    "plantCount",
    "fieldOperationDescription",
    "sowingMethod",
    "seedSource",
    "estimateYield",
    "estimateYieldTonne",
    "latitude",
    "longitude",
    "createdDate",
  ];

  const customHeaders = [
    "Farmer Name",
    "Farmer Code",
    "Executive Name",
    "State",
    "Village",
    "LGA",
    "Season",
    "crop Type",
    "Crop Name",
    "Variety Name",
    "Plot Area",
    "Unit",
    "Sowing Date",
    "Irrigation Date",
    "Land Preparation Type",
    "Field Operation",
    "Sowing/Transplanted Area",
    "Plant Count",
    "Field Operation Description",
    "Sowing Method",
    "Seed Source",
    "Estimated Yield(kg)",
    "Estimated Yield(tonne)",
    "Latitude",
    "Longitude",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "SowingProductReport.xlsx";
  
    // Process data to include latitude and longitude
    const processedData = data.map((item) => {
      let latitude = null;
      let longitude = null;
  
      if (item.entryLatLong) {
        try {
          const coord = JSON.parse(item.entryLatLong);
          latitude = coord.latitude || null;
          longitude = coord.longitude || null;
        } catch (error) {
          console.error("Error parsing entryLatLong:", error);
        }
      }
  
      return {
        ...item,
        estimateYieldTonne: (item.estimateYield / 1000).toFixed(2),
        latitude,
        longitude,
        createdDate: item.createdDate
        ? new Date(item.createdDate).toLocaleDateString()
        : null,
        irrigationDate: item.irrigationDate
        ? new Date(item.irrigationDate).toLocaleDateString()
        : null,
        fieldOperationDate: item.fieldOperationDate
        ? new Date(item.fieldOperationDate).toLocaleDateString()
        : null,
      };
    });
  
    // Pass the processed data to the convertToExcel function
    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };
  

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (state) => {
    var urlfilter = "";

    if (state && typeof state === "string" && state.trim().length > 0) {
      const sanitizedState = state.trim().replace(/[^a-zA-Z0-9_\- ]/g, "");
      urlfilter = urlfilter + `&stateName=${sanitizedState}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getStateData } = useHttp();
  useEffect(() => {
    getStateData(
      {
        url: `/api/stateLocation/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        // console.log("state", data);

        setStatedata(data);
      }
    );
     
  }, [getStateData]);

  const { sendRequest: getRegion } = useHttp();
  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      }
    );
  }, [getRegion]);

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Sowing Detail Reports
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              {" "}
              <br />
            </div>
            <div className="row"></div>
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                <label>State</label>
                  <select
                    id="stateName"
                    className="form-control"
                    ref={(el) => (frmRef.current["stateName"] = el)}
                    value={stateName}
                    onChange={(e) => {
                      var sName = "";

                      if (e.target.value != "--Select--") {
                        sName = e.target.value;
                        // console.log("sName", sName);
                      }
                      setStateName(sName);
                      EmployeeDetail(sName);
                      setData([]);
                      setEmployeeId(0);
                    }}
                  >
                    <option value="">Select</option>
                    {stateData &&
                      stateData.map((x) => (
                        <option
                          key={x.stateName}
                          user-id={x.stateName}
                          value={x.stateName}
                        >
                          {x.stateName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option>--Select--</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["fromDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["toDate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillprocurementData(employeeId, regionId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        <tr className="tableheaderrowview">
                          <th>Farmer Name</th>
                          <th>Farmer Code</th>
                          <th>Executive Name</th>
                          <th>State</th>
                          <th>Village</th>
                          <th>LGA</th>
                          <th>Season</th>
                          <th>crop Type</th>
                          <th>Crop Name</th>
                          <th>Variety Name</th>
                          <th>Plot Area</th>
                          <th>Unit</th>
                          <th>Sowing Date</th>
                          <th>Irrigation Date</th>
                          <th>Land Preparation Type</th>
                          <th>Field Operation</th>
                          <th>Sowing/Transplanted Area</th>
                          <th>Plant Count</th>
                          <th>Field Operation Description</th>
                          <th>Sowing Method</th>
                          <th>Seed Source</th>
                          <th>Estimated Yield(kg)</th>
                          <th>Estimated Yield(tonne)</th>
                          <th>Latitude</th>
                          <th>Longitude</th>
                          <th>Created Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.farmerName}</td>
                                <td>{itm.farmerNo}</td>
                                <td>{itm.executiveName}</td>
                                <td>{itm.state}</td>
                                <td>{itm.villageName}</td>
                                <td>{itm.lga}</td>
                                <td>{itm.seasonName}</td>
                                <td>{itm.cropType}</td>
                                <td>{itm.cropName}</td>
                                <td>{itm.varietyName}</td>
                                <td>{itm.plotArea}</td>
                                <td>{itm.plotAreaUnit} </td>
                                {/* <td>{itm.fieldOperationDate}</td> */}
                                <td>{new Date(itm.fieldOperationDate).toLocaleDateString()}</td>
                                <td>{new Date(itm.irrigationDate).toLocaleDateString()}</td>
                                <td>{itm.landPreparationType}</td>
                                <td>{itm.fieldOperationName}</td>
                                <td>{itm.transplantedArea}</td>
                                <td>{itm.plantCount}</td>
                                <td>{itm.fieldOperationDescription}</td>
                                <td>{itm.sowingMethod}</td>
                                <td>{itm.seedSource}</td>
                                <td>{itm.estimateYield}</td>
                                <td>{(itm.estimateYield / 1000).toFixed(2)}</td>
                                <td>
                                  {itm.entryLatLong &&
                                    (() => {
                                      const coord = JSON.parse(
                                        itm.entryLatLong
                                      );
                                      return <div>{coord.latitude}</div>;
                                    })()}
                                </td>
                                <td>
                                  {itm.entryLatLong &&
                                    (() => {
                                      const coord = JSON.parse(
                                        itm.entryLatLong
                                      );
                                      return <div>{coord.longitude}</div>;
                                    })()}
                                </td>
                                <td>{new Date(itm.createdDate).toLocaleDateString()}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerCropSowingDetailReport;
